var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyOrdersicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "65px",
    viewBox: "0 0 63 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "000-Empty",
    transform: "translate(-176.000000, -410.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ilust-order",
    transform: "translate(176.000000, 410.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DEF9FD",
    cx: 31.5,
    cy: 33.5,
    r: 31.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#7FDCF4",
    x: 0,
    y: 3.5999999,
    width: 46.7999988,
    height: 60.2999984,
    rx: 4.49999988
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0999988,53.9052617 L39.9813549,59.3999984 L35.8627109,53.9052617 L31.744067,59.3999984 L27.625423,53.9052617 L23.8499994,59.3999984 L20.0745757,53.9052617 L15.9559318,59.3999984 L11.8372878,53.9052617 L7.71864386,59.3999984 L3.5999999,53.9052617 L3.5999999,11.3579997 C3.5999999,9.06159978 5.46159987,7.19999981 7.75799981,7.19999981 L39.942,7.19999981 C42.2383999,7.19999981 44.0999999,9.06159978 44.0999999,11.3579997 L44.0999999,53.9052617 L44.0999988,53.9052617 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0999995,0 L30.5999998,0 C33.0852811,-4.5653877e-16 35.0999997,2.01471857 35.0999997,4.49999988 L35.0999997,9.89999974 L35.0999997,9.89999974 L12.5999997,9.89999974 L12.5999997,4.49999988 C12.5999997,2.01471857 14.6147182,4.5653877e-16 17.0999995,0 Z",
    id: "Rectangle",
    fill: "#1CC1EB"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOrdersicon);
export default __webpack_public_path__ + "static/media/empty-orders.icon.3cf977ac93a2a06f1a7757a670807e20.svg";
export { ForwardRef as ReactComponent };